import TEXTS from '../../../locale/texts';

export const importContactsColumns = (lang) => [
  {
    title: TEXTS.contactPhoneLabel[lang],
    dataIndex: 'msisdn'
  },
  {
    title: TEXTS.thPhoneGroups[lang],
    dataIndex: 'groups'
  },
  {
    title: TEXTS.thFIO[lang],
    dataIndex: 'firstname'
  },
  {
    title: TEXTS.contactCityLabel[lang],
    dataIndex: 'city'
  },
  {
    title: TEXTS.thGender[lang],
    dataIndex: 'gender'
  },
  {
    title: TEXTS.birthDate[lang],
    dataIndex: 'birthDate'
  }
];
